import PoolDetail from './PoolDetailContainer'

export default PoolDetail